<template>
  <div class="message">
    <div class="info_box">
      <div class="fliter">
        <div class="fliter_item" style="width: 200px">
          <el-input v-model="paginationData.projectNo" placeholder="请输入项目编号" style="width: 200px" clearable>
          </el-input>
        </div>
        <div class="fliter_item" style="width: 200px">
          <el-input v-model="paginationData.projectName" placeholder="请输入项目名称" style="width: 200px" clearable>
          </el-input>
        </div>
        <div class="fliter_item">
          <el-button type="primary" icon="Search" @click="searchData">检索</el-button>
        </div>
        <div class="fliter_item">
          <el-button plain icon="RefreshLeft" @click="resetData">重置</el-button>
        </div>
      </div>
      <el-table ref="multipleTable" :data="tableData" stripe border v-loading="loading">
        <el-table-column type="index" label="序号" width="80"></el-table-column>
        <el-table-column prop="projectName" label="项目名"></el-table-column>
        <el-table-column prop="projectNo" label="项目编号"></el-table-column>
        <el-table-column label="审核状态">
          <template #default="scope">
            <el-tag v-if="scope.row.status == '1'" type="info">待审核</el-tag>
            <el-tag type="primary" v-if="scope.row.status == '2'">审核中</el-tag>
            <el-tag type="success" v-if="scope.row.status == '3'">审核通过</el-tag>
            <el-tag type="danger" v-if="scope.row.status == '4'">驳回</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="报名时间"></el-table-column>
        <el-table-column label="操作" fixed="right" width="200px">
          <template #default="scope">
            <el-link type="primary" @click="dataDetail(scope.$index, scope.row)">查看详情</el-link>
            <el-divider direction="vertical" v-if="scope.row.status == '1' || scope.row.status == '4'"></el-divider>
            <el-link type="danger" v-if="scope.row.status == '1' || scope.row.status == '4'"
              @click="resubmit(scope.$index, scope.row)">重新提交</el-link>
            <!-- <el-divider direction="vertical"></el-divider>
            <el-link type="danger" @click="deleteAdministrators(scope.row)">删除</el-link> -->
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-wrap flex_end">
        <el-pagination background :current-page="paginationData.pageNum" :page-size.sync="paginationData.pageSize"
          @current-change="handleCurrentChange" layout="total, prev, pager, next"
          :total="paginationData.total"></el-pagination>
      </div>
    </div>
    <signupCom ref="signupRef" @refreshList="searchData" ></signupCom>

    <el-drawer v-model="dialogResubmit" title="报名详情" direction="rtl">
      <el-descriptions class="margin-top" :column="1" :size="size" border>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              姓名
            </div>
          </template>
          {{ signupDetails.userName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              联系电话
            </div>
          </template>
          {{ signupDetails.userPhone }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              证件号
            </div>
          </template>
          {{ signupDetails.userCode }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              是否需要缴纳保证金
            </div>
          </template>
          <el-tag size="small" v-if="signupDetails.takeFeeFlag == 'Y'">是</el-tag>
          <el-tag size="small" v-if="signupDetails.takeFeeFlag == 'N'">否</el-tag>
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              账号名称
            </div>
          </template>
          {{ signupDetails.bankAccountName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              开户行名称
            </div>
          </template>
          {{ signupDetails.bankName }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              银行卡号
            </div>
          </template>
          {{ signupDetails.bankNo }}
        </el-descriptions-item>
        <el-descriptions-item>
          <template #label>
            <div class="cell-item">
              付款凭证
            </div>
          </template>
          <div class=" flex_center">
            <el-image  style="width: 100px; height: 100px" v-for="(item, index) in signupDetails.fileList" :key="index" :src="item.url" fit="contain"></el-image>
          </div>
        </el-descriptions-item>
      </el-descriptions>
    </el-drawer>
  </div>
</template>

<script>
import { applyList, signReply } from "@/utils/api";
import signupCom from "@/components/signupCom.vue";
var moment = require("moment");
export default {
  components: {
    signupCom
  },
  data() {
    return {
      loading: false,
      tableData: [],
      singleCaseList: [],
      communityList: [],
      paginationData: {
        total: 0,
        pageNum: 1,
        pageSize: 10,
        projectNo: "",
        projectName: "",
        createBy: localStorage.userId,
      },
      now_id: 0,
      dialogResubmit: false,
      signupDetails: {},
    };
  },
  computed: {},
  mounted() {
    this.getData();
    // this.getConfig();
  },
  methods: {
    // 重新提交
    resubmit(index, row) {
      // this.dialogResubmit = true;
      this.signupDetails = row;
      this.$refs.signupRef.openPopup(row.projectId, row);
    },
    // 查看详情
    dataDetail(index, row) {
      this.dialogResubmit = true;
      this.signupDetails = row;
    },
    // 删除管理员
    deleteAdministrators(row) {
      this.$confirm("确认删除本条数据！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // this.templateId = row.id;
          this.deleteAdmin(row);
        })
        .catch(() => {
          return this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    async deleteAdmin(row) {
      let res = await this.$http.get("/user/delcomad", {
        token: localStorage.token,
        admin_id: row.id,
      });
      if (res.errcode == 200) {
        this.$message.success("删除成功!");
        this.paginationData.pageNum = 1;
        this.getData();
      } else {
        this.$message.error(res.errmsg);
      }
    },
    // 查看案例
    viewCase(id) {
      this.now_id = id;
      // this.getSingleCaseList();
    },
    async searchData() {
      this.paginationData.pageNum = 1;
      this.getData();
    },
    resetData() {
      this.paginationData.projectNo = "";
      this.paginationData.projectName = "";
      this.paginationData.pageNum = 1;
      this.getData();
    },
    async getData() {
      let res = await applyList(this.paginationData);
      if (res.code == 200) {
        this.loading = false;
        this.tableData = res.data.rows;
        this.paginationData.total = Number(res.data.total);
      }
    },
    async getConfig() {
      let res = await this.$http.get("/system/config", {
        token: localStorage.token,
      });
      if (res.errcode == 200) {
        this.communityList = res.data.coop;
      } else {
        this.$message.error(res.errmsg);
      }
    },
    handleCurrentChange(num) {
      this.paginationData.pageNum = num;
      this.getData();
    },
    dateFormat: function (row, column) {
      var date = row[column.property];
      if (date == undefined) {
        return "";
      }
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    formatTime(date) {
      return moment(date).format("YYYY-MM-DD HH:mm");
    },
    async handleEdit(index, row) { },
    typeFormart(row, index) {
      for (var i = 0; i < this.communityList.length; i++) {
        if (this.communityList[i].id == row.coopid) {
          return this.communityList[i].name;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.detail_box {
  padding: 25px;
}

.cert_img {
  margin-top: 25px;

  img {
    display: block;
    width: 100%;
  }
}
</style>
